<template>
  <vxe-modal
    ref="modal"
    v-model="formVisible"
    title="附件"
    width="80%"
    height="80%"
    @show="showModal"
  >
    <el-row :gutter="10">
      <el-col :span="14">
        <vxe-grid
          ref="xTable"
          size="mini"
          :column-config="{ minWidth: '80px' }"
          border
          keep-source
          :height="tableHeight"
          resizable
          show-overflow
          highlight-hover-row
          highlight-current-row
          :keyboard-config="{
            isArrow: true,
            isEnter: true,
            isTab: true,
            enterToTab: true,
            isClip: true,
          }"
          :mouse-config="{ area: true, extension: true }"
          :data="tableData"
          :columns="gridColumns"
        >
        </vxe-grid>
      </el-col>
      <el-col :span="10">
        <YKDivider>图片预览</YKDivider>
        <PreviewImage :height="imgHeight" :imgSrc="previewImgSrc" />
      </el-col>
    </el-row>
  </vxe-modal>
</template>
<script>
import { BASEURL } from '@/axios/baseUrlConfig.js'
export default {
  props: {
    files: {
      type: Array
    },
    cacheRow: {
      type: Object
    },
    parentObj: {
      type: Object
    }
  },
  data() {
    return {
      // 是否显示
      formVisible: false,
      // 数据
      tableData: [
      ],
      // 数据列
      gridColumns: [],
      // 预览的src
      previewImgSrc: ''
    }
  },
  created() {
  },
  methods: {
    // 删除附件
    async handleDelete(row) {
      let that = this
      const { data: res } = await that.$http.delete(`/Base/BAttachment/${row.id}`)
      if (res.isSuccess) {
        that.$message.success(that.messageConfig.del.success)
        await that.parentObj['handleAttachment'](this.cacheRow, 'del')
        // 如果还有附件的话赋值,否则窗口关闭
        if (this.files.length > 0) {
          this.tableData = this.files
        }
      } else {
        that.$message.error(res.errorMessage)
      }
    },
    // 下载附件
    async handleDown(row) {
      let upload = BASEURL.upload
      if (!upload) {
        upload = window.location.origin
      }
      let that = this
      const { data: res } = await that.$http.get(`/Base/BAttachment/secret`, {
        params: {
          link: `${upload}/download/${row.filePath}`
        }
      })
      // let fileType = row.type.toUpperCase()
      // if (['.HTML', '.TXT', '.JPG', '.JPEG', '.PNG', '.JIFF', '.ART', '.AU', '.AIFF', '.XBM', '.PDF'].includes(fileType)) {
      // 所有类型都转换，转换过后在下载 这样就不会存在跨域问题了
      const a = document.createElement('a')
      const url = res // 完整的url则直接使用
      // 这里是将url转成blob地址，
      fetch(url)
        .then(res => res.blob())
        .then(blob => {
          // 将链接地址字符内容转变成blob地址
          a.href = URL.createObjectURL(blob)
          a.download = row.display + row.type // 下载文件的名字
          // a.download = url.split('/')[url.split('/').length -1] //  // 下载文件的名字
          document.body.appendChild(a)
          a.click()
        })
      // } else {
      // todo download属性存在跨域导致失效 待考察
      //   let fileDownLink = document.createElement('a')
      //   fileDownLink.download = row.display + row.type
      //   fileDownLink.href = res
      //   fileDownLink.click()
      //   fileDownLink.remove()
      // }
    },
    // 预览图片
    async handleOpen(row) {
      if (['.jpg', '.png', '.jpeg', '.gif', '.jfif'].includes(row.type)) {
        // this.previewImgSrc = row.src
        let upload = BASEURL.upload
        if (!upload) {
          upload = window.location.origin
        }
        let that = this
        const { data: res } = await that.$http.get(`/Base/BAttachment/secret`, {
          params: {
            link: `${upload}/download/${row.filePath}`
          }
        })
        // const url = res // 完整的url则直接使用
        this.previewImgSrc = res
      } else {
        this.$message.error('预览只支持图片类型!')
      }
    },
    // 初始化列头
    InitColumn() {
      let that = this
      that.gridColumns = [
        { type: 'seq', width: '45' },
        {
          field: 'delete',
          title: '删除',
          width: '50',
          slots: {
            default: ({ row }) => {
              // 如果 [明细没有处理结果 且 (是本单位的信息 或是 (运维人员 或 管理员))] 时即可删除附件
              if (!this.cacheRow.handleResult && (this.cacheRow.userCompany === this.$store.state.userInfo.company || ['管理', '运维'].includes(this.$store.state.userInfo.gangWei))) {
                return [
                  <i
                    style="color: red"
                    class="el-icon-delete"
                    onClick={() => {
                      this.handleDelete(row)
                    }}
                  ></i>
                ]
              } else {
                return [
                  <i id="vxeDeleteDisabled" class="el-icon-delete-solid"></i>
                ]
              }
            }
          }
        },
        {
          title: '下载',
          align: 'center',
          width: '50',
          slots: {
            default: ({ row }) => {
              return [
                <i
                  class="el-icon-download"
                  onClick={() => {
                    this.handleDown(row)
                  }}
                ></i>
              ]
            }
          }
        },
        {
          title: '预览',
          align: 'center',
          width: '50',
          slots: {
            default: ({ row }) => {
              return [
                <i
                  class="el-icon-view"
                  onClick={() => {
                    this.handleOpen(row)
                  }}
                ></i>
              ]
            }
          }
        },
        {
          field: 'display',
          title: '文件名',
          slots: {
            default: ({ row }) => {
              return [
                <el-link
                  type="primary"
                  onClick={() => {
                    this.handleDown(row)
                  }}
                >
                  {row.display}
                </el-link>
              ]
            }
          }
        },
        { field: 'type', title: '文件类型' },
        { field: 'fileSize', title: '文件大小' },
        { field: 'eName', title: '上传人' },
        { field: 'uploadTime', title: '上传时间' },
      ]
    },
    showModal() {
      // 初始化列
      this.InitColumn()
      this.previewImgSrc = ''
      this.tableData = this.files
    }
  },
  computed: {
    // 表格高度
    tableHeight() {
      return this.$store.state.clientHeight * 0.8 - 80 + 'px'
    },
    // 图片高度
    imgHeight() {
      return this.$store.state.clientHeight * 0.8 - 85 - this.heightConfig.dividerHeight + 'px'
    },
  }
}
</script>
<style lang='less' scoped>
#vxeDeleteDisabled {
  color: #999;
}
</style>